
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/super-admin",
      function () {
        return require("private-next-pages/super-admin/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/super-admin"])
      });
    }
  